export const SubscriptionLength = [
	{ label: '1 Year', value: '1' },
	{ label: '2 Years', value: '2' },
	{ label: '3 Years', value: '3' },
];

export const SubscriptionStatus = [
	{ label: 'Pending', value: 0 },
	{ label: 'Active', value: 1 },
	{ label: 'Closed', value: 2 },
];
export enum KeyStagesEnum {
	KS4 = 'KS4',
	KS5 = 'KS5',
	KS4KS5 = 'KS4KS5',
}

export enum SubscriptionStatusEnum {
	Pending = 'Pending',
	Active = 'Active',
	Closed = 'Closed',
}

export enum KeyStages {
	KS4 = 1,
	KS5 = 2,
	KS4KS5 = 3,
}

export const KeyStagesOptions = [
	{ label: KeyStagesEnum.KS4, value: KeyStagesEnum.KS4 },
	{ label: KeyStagesEnum.KS5, value: KeyStagesEnum.KS5 },
	{ label: 'KS4/KS5', value: KeyStagesEnum.KS4KS5 },
];

export const subscriptionTypes = ['KS4', 'KS5', 'KS4KS5'];
